export const LOADING_SPINNER_STYLE = `
<style>
body, html {
    height: 100%;
    margin: 0;
    background-color: #f0f0f0;
}
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
<div class="overlay">
    <img src="assets/aumico_loader_rings.png" alt="Loading..." />
</div>
`;
